export default "__VITE_ASSET__Cm1H4ETl__"